module.exports = __webpack_public_path__ + "static/media/4922-16.fff034b5.jpg";